import React from "react";
import { cn } from "../../lib/utils";
import { Card } from "./card";

type SurfaceCardProps = {
  children: React.ReactNode;
  className?: string;
};

export const SurfaceCard: React.FC<SurfaceCardProps> = ({
  children,
  className,
}) => <Card className={cn("ds-card", className)}>{children}</Card>;
